import { render, staticRenderFns } from "./CaddieArrangementStatement.vue?vue&type=template&id=182b74c2&scoped=true&"
import script from "./CaddieArrangementStatement.vue?vue&type=script&lang=js&"
export * from "./CaddieArrangementStatement.vue?vue&type=script&lang=js&"
import style0 from "./CaddieArrangementStatement.vue?vue&type=style&index=0&id=182b74c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b74c2",
  null
  
)

export default component.exports